import Immutable from 'immutable';
import React from 'react';

import ColorButton from 'sharedreact/components/ColorButton';
import ParameterComponent from 'sharedreact/components/ParameterComponent';

type Props = {
  id: string,
  value: string,
  name: string,
  label: string,
  options: Immutable.List<string>,

  onChangeValue?: (key: string, value: string, event: React.SyntheticEvent) => void
};

class ColorButtonsField extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, label, name, value, options, onChangeValue } = this.props;

    const colorButtons: JSX.Element[] = options.map((option: string, index: number) => {
      return (
        <ColorButton id={id + '_' + option}
          key={option}
          color={option}
          active={value === option}
          onClick={onChangeValue != null ? (event: React.SyntheticEvent) => onChangeValue(name, option, event) : undefined}
        />
      );
    }).toJS();

    // colorButtons

    return (
      <ParameterComponent
        label={label}>
        <div className='esko_colorbuttons'>
          {colorButtons}
        </div>
      </ParameterComponent>
    );
  }
}

export default ColorButtonsField;
